export default function StatusPrivate({ width = '12', height = '16' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 16">
      <path id="padlock" d="M13.5,6H13V4A4,4,0,0,0,5,4V6H4.5A1.5,1.5,0,0,0,3,7.5v7A1.5,1.5,0,0,0,4.5,16h9A1.5,1.5,0,0,0,15,14.5v-7A1.5,1.5,0,0,0,13.5,6ZM6.333,4a2.667,2.667,0,1,1,5.333,0V6H6.333Zm3.333,7.148v1.519a.667.667,0,0,1-1.333,0V11.148a1.333,1.333,0,1,1,1.333,0Z" transform="translate(-3)" />
    </svg>
  );
}
